import { render, staticRenderFns } from "./ChatroomFeed.vue?vue&type=template&id=9d8e9878&scoped=true&"
import script from "./ChatroomFeed.vue?vue&type=script&lang=js&"
export * from "./ChatroomFeed.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomFeed.vue?vue&type=style&index=0&id=9d8e9878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8e9878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d8e9878')) {
      api.createRecord('9d8e9878', component.options)
    } else {
      api.reload('9d8e9878', component.options)
    }
    module.hot.accept("./ChatroomFeed.vue?vue&type=template&id=9d8e9878&scoped=true&", function () {
      api.rerender('9d8e9878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/chatroom/ChatroomFeed.vue"
export default component.exports